import { FiAnchor, FiTarget, FiToggleRight, FiUsers } from 'react-icons/fi';
import { NavLink } from 'react-router-dom';

import styles from '@/admin/components/AdminSidebar.module.scss';

const NAV_ITEMS = [
  { to: '/vh-admin/users', label: 'All Users', icon: <FiUsers /> },
  { to: '/vh-admin/vessels', label: 'All Vessels', icon: <FiAnchor /> },
  { to: '/vh-admin/features', label: 'All Features', icon: <FiToggleRight /> },
  { to: '/vh-admin/audiences', label: 'Audiences', icon: <FiTarget /> },
];

export const AdminSidebar = ({ onNavigate }: { onNavigate?: () => void }) => (
  <nav className={styles.nav}>
    {NAV_ITEMS.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        onClick={onNavigate}
        className={({ isActive }) => `${styles.link} ${isActive ? styles.linkActive : ''}`}
      >
        <span className={styles.icon}>{item.icon}</span>
        {item.label}
      </NavLink>
    ))}
  </nav>
);
